/** One install identity/sequence for every offline role queue. Credentials never enter this DB. */
export interface QueueIdentity {
  client_device: string;
  client_seq: number;
}
let opening: Promise<IDBDatabase> | undefined;
export async function allocateQueueIdentity(): Promise<QueueIdentity> {
  const db = await (opening ??= new Promise((resolve, reject) => {
    const request = indexedDB.open("scorio.queue-identity.v1", 1);
    request.onupgradeneeded = () => request.result.createObjectStore("identity");
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  }));
  return new Promise((resolve, reject) => {
    const tx = db.transaction("identity", "readwrite");
    const store = tx.objectStore("identity");
    const request = store.get("install");
    let identity: QueueIdentity;
    request.onsuccess = () => {
      const data = request.result ?? { device: crypto.randomUUID(), sequence: 0 };
      if (
        typeof data.device !== "string" ||
        !Number.isSafeInteger(data.sequence) ||
        data.sequence < 0 ||
        data.sequence >= Number.MAX_SAFE_INTEGER
      ) {
        tx.abort();
        return;
      }
      data.sequence++;
      identity = { client_device: data.device, client_seq: data.sequence };
      store.put(data, "install");
    };
    tx.oncomplete = () => resolve(identity);
    tx.onerror = () => reject(tx.error ?? new Error("Queue identity could not be saved"));
    tx.onabort = () => reject(tx.error ?? new Error("Queue identity is invalid"));
  });
}
